import { Routes, Route } from 'react-router-dom';
import { WeddingHome } from './pages/WeddingHome';
import { AdminView } from './pages/AdminView';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<WeddingHome />} />
      <Route path="/admin" element={<AdminView />} />
    </Routes>
  );
}
